import { Component, h, ComponentInterface, State, Prop } from '@stencil/core';
import { guid } from 'utils';


@Component({
	tag: 'kdx-comparison-card',
	styleUrl: 'kdx-comparison-card.scss',
	shadow: false
})
export class StComparisonCard implements ComponentInterface {
	@State() guid: string = guid();

	@Prop() heading: string;

	@Prop() ctaPrimaryText: string;
	@Prop() ctaPrimaryHref: string;
	@Prop() ctaPrimaryAriaLabel: string;
	@Prop() ctaPrimaryStyle: string = "btn btn-primary";
	@Prop({mutable: true}) ctaPrimaryTarget: string;
	@Prop() ctaPrimaryIcon: string = 'arrow-circle-right';
	@Prop() ctaPrimarySpeedbump: boolean;
	@Prop({
		mutable: true,
		reflect: true
	}) ctaPrimaryRel;

	@Prop() ctaSecondaryText: string;
	@Prop() ctaSecondaryHref: string;
	@Prop() ctaSecondaryAriaLabel: string;
	@Prop() ctaSecondaryStyle: string = "btn btn-secondary";
	@Prop({mutable: true}) ctaSecondaryTarget: string;
	@Prop() ctaSecondarySpeedbump: boolean;
	@Prop({
		mutable: true,
		reflect: true
	}) ctaSecondaryRel;

	componentWillLoad() {
		if (this.ctaPrimarySpeedbump || this.ctaPrimaryTarget && (this.ctaPrimaryTarget.toLowerCase() === '_blank')) {
			this.ctaPrimaryTarget = '_blank';
			this.ctaPrimaryRel = 'noopener';
		}

		if (this.ctaSecondarySpeedbump || this.ctaPrimaryTarget && (this.ctaSecondaryTarget.toLowerCase() === '_blank')) {
			this.ctaSecondaryTarget = '_blank';
			this.ctaSecondaryRel = 'noopener';
		}
	}

	render() {
		return (
		<kdx-card classes="kdx-comparison-card"
			heading={this.heading}
			cta-primary-text={this.ctaPrimaryText}
			cta-primary-href={this.ctaPrimaryHref}
			cta-primary-aria-label={this.ctaPrimaryAriaLabel}
			cta-primary-icon={this.ctaPrimaryIcon}
			cta-primary-style={this.ctaPrimaryStyle}
			cta-primary-target={this.ctaPrimaryTarget}
			cta-primary-speedbump={this.ctaPrimarySpeedbump}
			cta-secondary-text={this.ctaSecondaryText}
			cta-secondary-href={this.ctaSecondaryHref}
			cta-secondary-aria-label={this.ctaSecondaryAriaLabel}
			cta-secondary-style={this.ctaSecondaryStyle}
			cta-secondary-target={this.ctaSecondaryTarget}
			cta-secondary-speedbump={this.ctaSecondarySpeedbump}
		>
			<div class="product-content">
				<slot />
			</div>
		</kdx-card>
		);
	}
}